import * as React from 'react';

import WorkflowTemplate32 from './WorkflowTemplate32';

export const workflowTemplate32 = () => <WorkflowTemplate32 />;

export default {
    title: 'Icon|Content|WorkflowTemplate32',
    component: WorkflowTemplate32,
    parameters: {
        notes: "`import WorkflowTemplate32 from 'box-ui-elements/es/icon/content/WorkflowTemplate32';`",
    },
};
